import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import "./customModal.css";

interface Props{
  show: boolean;
  title?: string | ReactNode;
  onClose: () => void;
  headerContent?: ReactNode;
  bodyContent?: ReactNode;
  footerContent?: ReactNode;
  size?: "lg" | "sm" | "xl";
  zindex?: number;
  dialogClassName?: string;
  backdrop?: boolean | "static" | undefined,
  hideHeader?: boolean;
  headerClassName?: string;
}

const CustomModal: React.FC<Props> = ({ 
  show, 
  onClose, 
  title, 
  headerContent, 
  bodyContent, 
  footerContent,
  size = undefined,
  dialogClassName,
  zindex,
  backdrop,
  hideHeader = false,
  headerClassName,
}) => {

  return (
    <Modal
      zindex={zindex}
      backdrop={backdrop}
      show={show}
      onHide={() => {
        onClose();
      }}
      size={size}
      style={zindex ? {zIndex: zindex} : undefined}
      centered
      dialogClassName={dialogClassName}
      
    >
      {!hideHeader && <Modal.Header
      closeButton closeVariant="custom" className="d-flex justify-content-between align-items-start">
        <div className={`d-flex flex-wrap d-row ${headerClassName}`}> 
          {title && <Modal.Title>{title}</Modal.Title>}
          {headerContent && headerContent}
        </div>
      </Modal.Header>
      }
      <Modal.Body>
          {bodyContent}
      </Modal.Body>
      <Modal.Footer>
          {footerContent}
      </Modal.Footer>
    </Modal>
  );
}

export default CustomModal;